import { createRef } from "react";
export var defaultContext = {
  isDark: false,
  source: '',
  designMode: undefined,
  sectionRef: /*#__PURE__*/createRef(),
  currentRoute: undefined,
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  scrollTop: function scrollTop() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  openSideBar: function openSideBar() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  closeSideBar: function closeSideBar() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  onRouteChange: function onRouteChange() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  toggleSideBar: function toggleSideBar() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  toggleDesignMode: function toggleDesignMode() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  openErrorSnackbar: function openErrorSnackbar() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  updateCurrentRoute: function updateCurrentRoute() {},
  // biome-ignore lint/suspicious/noEmptyBlockStatements: intentional empty block
  toggleMobileSideBar: function toggleMobileSideBar() {}
};